
export default function FormsExtensionTrial() {
  return (
    <section className="py-24 bg-gradient-to-br from-teal-600 via-cyan-600 to-teal-700 relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 leading-tight">
              <strong>立即开始免费试用</strong>
            </h2>
            <p className="text-xl mb-8 text-white/90 leading-relaxed">
              注册即可获得<strong>30天专业版</strong>免费试用，体验完整的<strong>智能表单处理</strong>功能
            </p>
            
            <ul className="space-y-4 mb-8">
              <li className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg mr-4">
                  <i className="ri-check-line text-xl text-white"></i>
                </div>
                <span className="text-lg">无需信用卡，即刻开始</span>
              </li>
              <li className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg mr-4">
                  <i className="ri-check-line text-xl text-white"></i>
                </div>
                <span className="text-lg">完整功能访问权限</span>
              </li>
              <li className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg mr-4">
                  <i className="ri-check-line text-xl text-white"></i>
                </div>
                <span className="text-lg">专业技术支持团队</span>
              </li>
            </ul>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <button className="bg-white text-teal-600 hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-semibold transition-all shadow-lg whitespace-nowrap cursor-pointer">
                <i className="ri-rocket-line mr-2"></i>
                开始免费试用
              </button>
              <button className="border-2 border-white text-white hover:bg-white hover:text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer">
                <i className="ri-customer-service-2-line mr-2"></i>
                联系销售
              </button>
            </div>
          </div>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <h3 className="text-2xl font-bold text-white mb-6">
              <strong>试用期包含</strong>
            </h3>
            
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-file-list-3-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-white mb-2">50,000次API调用</h4>
                  <p className="text-white/80">充足的调用额度，满足测试需求</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-white mb-2">企业级安全保障</h4>
                  <p className="text-white/80">数据加密传输和存储</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-customer-service-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-white mb-2">优先技术支持</h4>
                  <p className="text-white/80">专业团队快速响应</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
